import { CIcon } from '~/icons/types'

export const ciGokarts: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M12.244 11.059a.476.476 0 0 0 .346-.145l.61-.61 1.945 2.335c.27-.202.571-.36.891-.47l-.075-.094L13.9 9.602l.671-.67a.49.49 0 1 0-.694-.694L11.9 10.22a.488.488 0 0 0 .157.8c.06.026.123.038.187.039Zm9.216 2-.1-.211a6.33 6.33 0 0 0-3.07-3.1h-.009c-.047-.02-.089-.042-.141-.061L16 8.756a.491.491 0 1 0-.393.9l2.142.933h.014c.037.014.075.033.112.047a5.349 5.349 0 0 1 2.489 2.414l-.984-.023a3.167 3.167 0 0 1 .567 3.464h3.01a.493.493 0 0 0 .495-.49v-.951a2 2 0 0 0-1.992-1.991Zm-17.996-.917V9.578a1.714 1.714 0 0 0-1.44 1.552v.9a3.328 3.328 0 0 1 1.439.112Zm6.236.357a18.68 18.68 0 0 1-3.61-4.406l-.737-1.245a.492.492 0 0 0-.796-.075.474.474 0 0 0-.113.263v5.61h5.428c-.052-.042-.113-.098-.172-.147Zm4.545 1.134H5.292a3.185 3.185 0 0 1 .338 2.212l.417.474a.488.488 0 0 0 .37.168h7.725a3.155 3.155 0 0 1 .127-2.854h-.024Z'
    },
    {
      d:
        'M17.049 12.984a2.18 2.18 0 0 0-1.786.92c-.005.013-.019.023-.024.037a2.192 2.192 0 0 0 0 2.493c0 .014.019.024.024.038a2.2 2.2 0 1 0 1.786-3.488Zm-12.465.884a2.227 2.227 0 1 0 0 2.6c.005-.014.019-.023.024-.037a2.22 2.22 0 0 0 0-2.522c-.008-.018-.019-.027-.024-.04Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'gokarts',
  type: 'solid'
}
